<template>
  <div class="gray-back">
    <div class="box">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
          <div class="row-list" v-for="(order, index) in list" :key="index">
            <div class="justify-space-flex row-title">
              <div class="title-left flex-start gray">
                <img class="row-title-img" src="https://static.dierqudao.com/images/dinghuoxitong/icon-date.png" alt="">
                <span>{{order.create_time | timeFormat}} 申报</span>
              </div>
                <div class="title-right gray" v-if="order.memberstatus===1">完善人员信息</div>
                <div class="title-right gray" v-else-if="order.memberstatus===2">完成联系人信息</div>
                <div class="title-right gray" v-else-if="order.memberstatus===6">报名成功</div>
            </div>
            <div class="justify-space-flex row-goods"  >
              <div class="row-left flex-start">
                <div class="goods-detail">
                  <div class="goods-name">
                    {{ order.danwei }}
                    <div>{{order.num}}</div>
                    <div>{{order.saiqu_name}}</div>
                    <div>人数:{{order.member_count}}</div>
                  </div>
                  <div class="goods-weight gray-light">
                    联系人:{{order.ldname}} 电话:{{order.phone}}
                  </div>
                </div>
              </div>
              <!--              <div class="row-right">-->
              <!--                <div class="goods-num gray-light">人数 {{order.members}}</div>-->
              <!--              </div>-->
            </div>
            <div class="row-btn">
              <!--              <div class="look-order">删除</div>-->
              <div class="look-order" @click="toMember(order)">{{order.memberstatus == 6 ? '查看人员' : '完善人员'}}</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>

      <van-action-sheet v-model="actionShow" :actions="actions" @select="onActionSelect"/>

      <div class="savebtn">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round
            @click="toCert">运动员备案
        </van-button>

        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."
            @click="addShow=true">能力测试申报
        </van-button>
      </div>


      <van-popup
          position="bottom"
          :style="{ height: '85%' }"
          v-model="addShow"
          @click-overlay="addShow=false"
      >
        <div style="margin-top: 0.2rem ; margin-bottom: 1.5rem">
          <van-form
              @submit="onSubmit"
              @failed="onFailed"
          >
            <van-divider>个人能力申报</van-divider>
            <van-cell-group>
              <van-field
                  readonly
                  clickable
                  right-icon="arrow"
                  input-align="right"
                  @click="showSaijiPicker=true"
                  label="所属年份"
                  v-model="saijiValue"
              />
              <van-popup v-model="showSaijiPicker" position="bottom">
                <van-picker :columns="saijiColumns"
                            show-toolbar
                            @cancel="showSaijiPicker = false"
                            @confirm="onSaijiConfirm"
                />
              </van-popup>
              <van-field
                  readonly
                  clickable
                  right-icon="arrow"
                  input-align="right"
                  @click="showSaiquPicker=true"
                  label="所属场次"
                  v-model="saiquValue"
              />
              <van-popup v-model="showSaiquPicker" position="bottom" @open="onSaiquOpen">
                <van-picker :columns="saiquColumns"
                            show-toolbar
                            @cancel="showSaiquPicker = false"
                            @confirm="onSaiquConfirm"
                />
              </van-popup>
              <van-field
                  readonly
                  clickable
                  name="area"
                  :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
                  input-align="right"
                  label="邮寄地区"
                  placeholder="点击选择省市区"
                  @click="showArea = true"
              />
              <van-popup v-model="showArea" position="bottom">
                <van-area
                    :area-list="areaList"
                    :value="formData.area"
                    @confirm="onAreaConfirm"
                    @cancel="showArea = false"
                />
              </van-popup>
              <van-field
                  v-model="formData.danwei"
                  :rules="[{ required: true, message: '单位名称不能为空' }]"
                  label="单位全称"
                  input-align="right"
                  error-message-align="right"
                  clearable
                  placeholder="请输入单位名称"
              />

              <van-field
                  v-model="formData.ldname"
                  label="联系人"
                  :rules="[{ required: true, message: '姓名不能为空' }]"
                  error-message-align="right"
                  input-align="right"
                  clearable
                  placeholder="请输入姓名"
              />

<!--              <van-cell title="身份证照片" :value="formData.shenfenzheng_pic.length+'/2'">-->
<!--              </van-cell>-->
<!--              <div class="row">-->
<!--                <PicUploader :fileList="formData.shenfenzheng_pic" :limit="2"-->
<!--                             :name="'shenfenzheng_pic'"></PicUploader>-->
<!--              </div>-->
<!--              <div class="operate-desc-left">上传身份证正面、背面照片</div>-->
              <van-field
                  v-model="formData.phone"
                  :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                  error-message-align="right"
                  label="联系电话"
                  input-align="right"
                  clearable
                  placeholder="请输入联系电话"
              />
              <van-field
                  v-model="formData.weixin"
                  :rules="[{ required: true, message: '微信不能为空' }]"
                  error-message-align="right"
                  label="微信"
                  input-align="right"
                  clearable
                  placeholder="请输入微信"
              />
              <van-field
                  v-model="formData.email"
                  :rules="[{ validator: validator.email,message:'请输入正确的邮箱'} ]"
                  error-message-align="right"
                  label="邮箱"
                  input-align="right"
                  clearable
                  placeholder="请输入邮箱"
              />
              <van-field
                  v-model="formData.address"
                  :rules="[{ required: true, message: '地址不能为空' }]"
                  error-message-align="right"
                  label="邮寄地址"
                  input-align="right"
                  clearable
                  placeholder="请输入邮寄地址"
              />

              <van-field
                  readonly 
                  clickable
                  right-icon="arrow"
                  input-align="right"
                  label="人员选择"
                  placeholder="请选择人员"
                  @click="showYundongyuanPicker=true"
              />
              <YundongyuanPicker
                  :show="showYundongyuanPicker"
                  :limit="30"
                  @onChange="onYundongyuanChange"
                  @onClose="showYundongyuanPicker=false"
                  :defaultValue="formData.yundongyuan"
                  @onConfirm="onYundongyuanConfirm"
              ></YundongyuanPicker>

              <div class="memberResultWrap" v-show="formData.yundongyuan.length>0">
                <div class="memberLi" v-for="(yundongyuan ,index) in formData.yundongyuan">
                  <van-tag
                      :key="index"
                      round
                      color="#fff"
                      text-color="#666"
                      size="large"
                      closeable
                      type="primary"
                      @close="formData.yundongyuan.splice(index,1)"
                  > {{ yundongyuan.name }}({{ yundongyuan.num }}) {{ yundongyuan.project }}-{{ yundongyuan.grade }}
                  </van-tag>
                </div>
              </div>

            </van-cell-group>

            <div class="savebtn">
              <van-button
                  color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                  style="width: 3rem"
                  size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."
                  native-type="submit">保存
              </van-button>
            </div>
          </van-form>
        </div>
      </van-popup>
      <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>

    </div>
  </div>
</template>
<style scoped>

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.box {
  /*margin-bottom: 50px;*/
  background: rgba(248, 248, 248, 1);
  min-height: 90vh;
}

.kaojicenter-list-box {
  padding-top: 0.2rem;
  /*background: rgba(248,248,248,1);*/
}

.goods-line {
  height: 55px;
}

.goods-bottom-line {
  width: 100%;
  position: fixed;
  height: 60px;
  bottom: 0;
  background: linear-gradient(180deg, hsla(255, 0%, 100%, 0), #fff);
}

.goods-create-btn {
  position: fixed;
  bottom: 10px;
  width: 100%;
  height: 44px;
  font-size: 16px;
  text-align: center;
}

.goods-create-btn button {
  width: 3.2rem;
}

.goods-create-btn img {
  width: 60px;
  height: 60px;
}

.goods-header {
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100%;
  margin-bottom: 0.01rem;
  background: #fff;
}

.van-tabs {
  /*width: 85% !important;*/
}

.screen-btn {
  line-height: 44px;
  height: 44px;
}

.screen-btn img {
  width: 45%;
  padding-left: 15px;
  vertical-align: middle;
  border-left: 1px solid #D5D5D5;
}

.sidebar {
  padding-top: 15px;
}

.search-box img {
  width: 60px;
  height: 60px;
}


.select-btn {
  position: fixed;
  bottom: 0;
  width: 90%;
  margin: 0 auto;
  padding: 0px 15px 30px;
}

.btn-reset {
  padding-bottom: 10px;
}

.btn-reset >>> .van-button {
  background: #ddd;
}

.selected {
  color: #444;
}


.kaojicenter-lists {
  padding: 0.2rem;
  border-radius: 10px;
  background: #fff;
  margin: 0 0.2rem 0.2rem;
}

.kaojicenter-lefts {
  position: relative;
}


.kaojicenter-lefts .img {
  border-radius: 10px;
  width: 1rem;
  height: 1rem;
}

.kaojicenter-rights {
  width: calc(100% - 1.2rem);
  position: relative;
  height: 1rem;
}

.kaojicenter-rights .title {
  font-size: 15px;
  font-weight: bold;
}

.kaojicenter-rights .desc {
  font-size: 12px;
  padding-top: 10px;
  color: #999;
}

.row-list {
  border-bottom: 0.1rem solid #EFEFEF;
  background: #fff;
  margin: 0.2rem;
  border-radius: 0.2rem;
}

.row-title-img {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.1rem;
}

.row-title {
  padding: 0.1rem 0.33rem;
}

.title-right {
  color: #FD2840;
}


.row-left {
  width: 80%;
}

.row-right {
  text-align: center;
}

.goods-detail {
  width: 72%;
}

.row-left-img {
  width: 1.44rem;
  height: 1.44rem;
  border-radius: 5px;
  margin-right: 0.2rem;
}

.row-goods {
  padding: 0.2rem 0.3rem;
  border-bottom: 1px solid #EFEFEF;
}

.goods-name {
  /*font-size: 12px;*/
  margin-bottom: 0.2rem;
}

.goods-price {
  font-size: 16px;
  margin: 0.1rem 0 0.6rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(253, 40, 64, 1);
}

.goods-price span {
  font-size: 12px;
}

.goods-num {
  font-size: 12px;
}

.pay_order {
  width: 87px;
  height: 26px;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 13px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 26px;
  margin-right: 0.5rem
}

.row-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.2rem 0.33rem;
  font-size: 12px;
  text-align: center;
  line-height: 0.52rem;
}

.look-order {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 26px;
  width: 75px;
  height: 26px;
  border-radius: 13px;
  border: 1px solid rgba(0, 0, 0, 1);
  margin-right: 0.5rem;
}

.invite-btn {
  width: 2.1rem;
  height: 0.52rem;
  background: rgba(255, 0, 0, 1);
  border: 1px solid rgba(255, 0, 0, 1);
  border-radius: 4px;
  color: #fff;
}
</style>

<script>
import Vue from 'vue';
import validator from "../../../utils/validator";
import IdCardPicker from "../../../components/picker/IdCardPicker.vue";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';
import YundongyuanPicker from '@/components/picker/YundongyuanAbilityPicker.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  CellGroup,
  Toast,
  Dialog,
  Icon,
  PullRefresh,
  List,
  Tag,
  Button,
  DropdownMenu,
  DropdownItem,
  DatetimePicker
} from 'vant';
import area from "../../../utils/area";

Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(DropdownItem).use(DatetimePicker);
export default {
  name: 'AbilityApplyList',
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    IdCardPicker,
    PicUploader,
    FileUploader,
    YundongyuanPicker,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      id: 0,
      active: 0,
      showDate: false,
      showArea: false,
      loginShow: false,
      showGradePicker: false,
      showYundongyuanPicker: false,
      showSaijiPicker: false,
      showSaiquPicker: false,
      actionShow: false,
      addShow: false,
      list: [],
      areaList: {},
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2015, 0, 1),
      showNumTypePicker: false,
      saijiColumns: [],
      saiquColumns: [],
      actions: [
        {name: '隐藏'},
        {name: '认证'},
      ],
      params: {
        pageNo: 1,
        pageSize: 10,
        keywords: '',
        cate_id: 0,
        is_show: 1
      },
      formData: {
        year: '', ldname: '', danwei: '', namekey: '', province: '', city: '', county: '', shenfenzheng_pic: [],
        phone: '', weixin: '', email: '', address: '', yundongyuan: []
      },
      saveLoading: false,
      isLoading: false,
      loading: false,
      finished: false,
      saijiValue: '',
      saiquValue: '',
    }
  },
  mounted() {
    document.title = "能力测试报名"
    this.areaList = area;
    this.getList();
    this.getOptions();
  },
  computed: {},
  filters: {
  },
  destroyed() {
  },
  methods: {
    getOptions() {
      let that = this;
      that.$api.get('/api/ability/saijiOptions', {}, (res) => {
        that.saijiColumns = res.data
      })
    },

    getSaiquOptions() {
      let that = this;
      that.$api.get('/api/ability/saiquOptions', {
        saiji: that.formData.saiji
      }, (res) => {
        that.saiquColumns = res.data
      })
    },
    getList() {
      let that = this;
      that.$api.get('/api/ability/applyList', that.params, (res) => {
        that.loading = false;

        // if (res.data.member_count === 0) {
        //   Dialog.alert({
        //     title: '请先备案',
        //     message: '申报前请先进行技术等级运动员备案',
        //     confirmButtonText: '进行技术等级运动员备案'
        //   }).then(() => {
        //     // on close
        //     rbLink({
        //       name: 'AbilityApplyMemberList'
        //     })
        //   });
        // }

        if (res.data.currentpage == 1) {
          that.isLoading = false;
          that.list = res.data.list
        } else {
          let list = that.list.concat(res.data.list);

          that.list = list;
        }

        if (res.data.list.length == 0) {
          that.finished = true;
        }
        that.params.pageNo += 1;
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },

    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.getList();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },
    onYundongyuanConfirm(values) {
      this.showYundongyuanPicker = false;
      this.formData.yundongyuan = [...values];
    },
    onYundongyuanChange(values) {
      console.log('onYundongyaunChange', values)
      this.formData.yundongyuan = [...values];
    },
    toCert() {
      rbLink({
        name: 'AbilityApplyMemberList',
      })
    },

    toMember(row) {
      rbLink({
        name: 'AbilityApplyMemberService',
        query: {
          id: row.id
        }
      })
    },
    onAreaConfirm(values) {
      console.log(values);
      this.formData.namekey = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },

    onSaijiConfirm(value) {
      console.log(value)
      this.formData.saiji = value.id;
      this.saijiValue = value.text
      this.saiquValue = ''
      this.formData.saiqu = ''
      this.getSaiquOptions()
      this.showSaijiPicker = false;
    },

    onSaiquOpen() {
      if(!this.formData.saiji) {
        Toast('请先选择所属年份')
      }
    },

    onSaiquConfirm(value) {
      console.log(value)
      this.showSaiquPicker = false;
      if(value == undefined) return
      this.formData.saiqu = value.id;
      this.saiquValue = value.text
      this.getSaiquOptions()
    },

    // 上拉加载
    // （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
    // 可以延迟异步的时间
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log('this.params.pageNo')

      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.getList()
        }, 500);
      }

    },

    onCopy(e) {
      Toast.success('复制成功');
    },
    onError(e) {
      console.log('复制失败！');
    },

    // 分享给家长
    onShareParent() {
      let that = this
      appEvent({
        name: 'shareWeixinFriend',
        query: that.share_data
      });
    },

    download(file, name){
      appEvent({
        name: 'downloadFile',
        query: {
          name: name,
          url: file
        }
      });
    },


    action(item, index) {

      this.actionShow = true;
      this.params.id = item.id;
      this.params.name = item.name;
      this.actions = [];
      if (item.is_show == 1) {
        this.actions.push({name: '隐藏'});
      } else {
        this.actions.push({name: '显示'});
      }
      if (item.cert_status == 2) {
        this.actions.push({name: '认证'});
      } else {
      }

    },
    onActionSelect(action, index) {
//                console.log(action); return ;
      let that = this;
      switch (index) {
        case 0 :
          if (action.name == '隐藏') {
            Dialog.confirm({
              title: '确认',
              message: '是否隐藏该运动员?',
            })
                .then(() => {
                  // on confirm
                  that.$api.post('/api/yundongyuan/hide', {
                    id: that.params.id
                  }, (res) => {
                    that.onRefresh();
                  }, (res) => {
                    Toast.fail(res.msg);
                  })

                })
                .catch(() => {
                  // on cancel
                });
          } else {
            that.$api.post('/api/yundongyuan/show', {
              id: that.params.id
            }, (res) => {
              that.onRefresh();
            }, (res) => {
              Toast.fail(res.msg);
            })
          }

          this.actionShow = false;
          break;

        case 1 :
          //认证
          // on confirm
          that.$api.post('/api/yundongyuan/cert', {
            id: that.params.id
          }, (res) => {
            that.onRefresh();
          }, (res) => {
            Toast.fail(res.msg);
          })
          break;

        case 2 :


          break;

      }
      this.actionShow = false;
    },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.getList();
    },

    onDateConfirm(date) {
      console.log('onDateConfirm', date);
      this.showDate = false;
      this.formData.birthday = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    submit() {

    },
    onNumTypeConfirm(value, index) {
      this.formData.numTypeName = value;
      this.formData.cardtype = index + 1;
      this.showNumTypePicker = false;
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    onFamilyIdSuccess(data) {
      console.log('onIdSuccess', data);
      this.formData.jianhuname = data.name;
      this.formData.jianhunum = data.cardNum;
    },
    onIdSuccess(data) {
      console.log('onIdSuccess', data);
      this.formData.name = data.name;
      this.formData.num = data.cardNum;
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {
        if (!this.formData.namekey) {
          Toast('请选择所属地区');
          return
        }

        if (!this.formData.saiji) {
          Toast('请选择所属年份');
          return
        }

        if (!this.formData.saiqu) {
          Toast('请选择所属场次');
          return
        }

        // if (!this.formData.shenfenzheng_pic.length) {
        //   Toast('请上传身份证照片');
        //   return
        // }
        //
        if (!this.formData.yundongyuan.length) {
          Toast('请选择人员');
          return
        }
      }
      that.saveLoading = true;
      that.$api.post('/api/ability/abilityApply', that.formData, (res) => {
        that.saveLoading = false;
        that.addShow = false;
        that.formData = {
          year: '', ldname: '', danwei: '', namekey: '', province: '', city: '', county: '', shenfenzheng_pic: [],
          phone: '', weixin: '', email: '', address: '', yundongyuan: []
        };
        Toast.success('申报成功')
        that.onRefresh()
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },


    // 更改状态
    onStatusChange(index) {

      let that = this;
      that.params.is_show = index + 1;
      that.params.pageNo = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];

      this.$route.query.is_show = 0;
      that.getList()
    },


  }
}
</script>



// WEBPACK FOOTER //
// AbilityApplyStep4.vue?b09d3688